import { BaseSerializer } from "../../../shared/models/serializers/baseSerializer.ts";
import { LayerData } from "../layers/layerData.model.tsx";
import { AudioSerializer } from "./audioSerializer.ts";
import { ColorSerializer } from "./colorSerializer.ts";
import { CompositionSerializer } from "./compositionSerializer.ts";
import { ImageSerializer } from "./imageSerializer.ts";
import { TextSerializer } from "./textSerializer.ts";
import { VideoSerializer } from "./videoSerializer.ts";

export class LayerSerializer extends BaseSerializer{

    private serializers: Record<string, any> = {
        color: new ColorSerializer(),
        text: new TextSerializer(),
        video: new VideoSerializer(),
        image: new ImageSerializer(),
        composition: new CompositionSerializer(),
        audio: new AudioSerializer(),
      };
    
      deserialize(data: any): LayerData {
        const serializer = this.serializers[data.type];
        if (!serializer) {
          throw new Error(`No serializer found for type: ${data.type}`);
        }
        
        return serializer.deserialize(data);
      }

}
